export default {    
    Java: `import java.util.Scanner;
    public class Fibonnaci{
        public static void main(String args[]) {
            Scanner myObj = new Scanner(System.in);
            System.out.println("Type the maximum number:");
            int n = myObj.nextInt();
            int sum = 0;
            int term1 = 0;  
            int term2 = 2;  
            while (term2 <= n) {
                sum = sum + term2;
                term2 = 4*term2 + term1;
                term1 = (term2-term1)/4;
            }
            System.out.println(Integer.toString(sum));
        }
    }
`,
    JavaScript: `function runner(MaxLimit){
    let sum = 0, term1 = 0, term2 = 2
    while (term2 < n) {
        sum = sum + term2
        term2 = 4*term2 + term1
        term1 = (term2-term1)/4
    }
    console.log(sum)
}
runner(4000000)`
,
    Python: `sum, term1, term2 = 0, 0, 2
maxN = int(input('Enter the maximum number: '))
while term2 < maxN:
    sum, term1, term2 = sum + term2, term2, 4 * term2 + term1
print ("Sum of even Fibonacci numbers is: ", sum)
`
}